export default "__VITE_ASSET__vg9BTcZi__"